export default __webpack_public_path__ + "static/media/tutrial4.63989a74.gif";